import { DataGrid, GridColumns } from '@material-ui/data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { useDevolucaoSaidaNFEForn } from '~/pages/DevolucaoESaidaNFDeFornecedor/DevolucaoSaidaNFEFornContext';
import {
  Parcela,
  ParcelaFinanceiro,
} from '~/pages/DevolucaoESaidaNFDeFornecedor/protocols';
import { formatCurrencyAsText } from '~/utils/functions';
import { ButtonRow, TableContainer } from './styles';
import Swal from 'sweetalert2';
import { MdDeleteForever } from 'react-icons/md';
import CustomDataGrid from '../../Nfe/Itens/CustomDataGrid';
import { deleteItens } from '~/utils/masterDetail';
import { createDateWithoutTimezone } from '~/utils/createDateWithoutTimezone ';

export const TableFinanceiro: React.FC = () => {
  const {
    parcelasFinanceiro,
    setParcelasFinanceiro,
    isUpdate,
    setParcelaSelecionada,
    masterDetail,
    setMasterDetail,
    setUuidParcela,
    formFinanceiro: { setValue, reset },
  } = useDevolucaoSaidaNFEForn();

  const columns: any = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'num_registro',
      headerName: 'Num. Registro',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'num_condicao',
      headerName: 'Prazo',
      width: 80,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'cod_condicao',
      headerName: 'Cód. Condicao',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_condicao',
      headerName: 'Condição',
      width: 300,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'dta_vencimento',
      headerName: 'Vencimento',
      disableColumnMenu: true,
      flex: 1,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            {moment(createDateWithoutTimezone(row.dta_vencimento)).format(
              'DD/MM/YYYY',
            )}
          </>
        );
      },
    },
    {
      field: 'val_parcela',
      headerName: 'Valor',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{formatCurrencyAsText(row.val_parcela)}</span>
          </>
        );
      },
    },
    {
      field: 'cod_finalizadora',
      headerName: 'Cód. Finalizadora',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_finalizadora',
      headerName: 'Finalizadora',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: '',
      headerName: 'Ações',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              type="button"
              disabled={isUpdate}
              isBlocked={isUpdate}
              onClick={() => onEditItem(row.uuid, row?.cod_parcela)}
              title="Editar"
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              type="button"
              disabled={isUpdate}
              isBlocked={isUpdate}
              onClick={() => onRemoveItem(row.uuid)}
              title="Remover"
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  const onEditItem = (uuid: string, cod_parcela: number | undefined) => {
    const reg = parcelasFinanceiro.find(
      (parcela: any) => parcela.uuid === uuid,
    );

    if (reg) {
      setValue('condicao', {
        label: reg.des_condicao,
        value: reg.cod_condicao,
      });
      setValue('finalizadora', {
        label: reg.des_finalizadora,
        value: reg.cod_finalizadora,
      });
      setValue('dta_vencimento', reg.dta_vencimento);
      setValue('val_financeiro', formatCurrencyAsText(reg.val_parcela));
      setValue('num_condicao', reg.num_condicao);
      setValue('num_registro', reg.num_registro);
      setUuidParcela({ uuid, cod_parcela });
    }
  };

  const onRemoveItem = (uuid: string) => {
    Swal.fire({
      title: ``,
      text: 'Deseja realmente remover essa parcela?',

      showCancelButton: true,
      confirmButtonColor: '#07289e',
      cancelButtonColor: '#ff7b7b',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteItens('parcelas', uuid, masterDetail, setMasterDetail);
        const parcels = parcelasFinanceiro.filter((p) => p.uuid !== uuid);

        setParcelasFinanceiro(parcels);
        handleClearForm;
      }
    });
  };
  const handleClearForm = () => {
    reset({
      num_condicao: 30,
      condicao: {
        value: 2,
        label: '2 - DD - (DIAS DA DATA)',
        cod_condicao: 2,
        des_condicao: 'DIAS DA DATA',
        des_definicao: 'DD',
      },
      finalizadora: '',
      dta_vencimento: '',
      val_parcela: '',
    });
    setUuidParcela(undefined);
  };

  return (
    <TableContainer>
      <DataGrid
        rowsPerPageOptions={[5]}
        rows={parcelasFinanceiro}
        columns={columns}
        pageSize={5}
        disableColumnSelector
        disableColumnFilter
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado...',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </TableContainer>
  );
};
